import moment from 'moment';
import * as settlementService from '@/services/settlements-api.service';
import vuei18n from '@/plugins/vue-i18n';
import * as arcService from '@/services/arc-api.service'
export default {
  settlements: (state) => {
    return state.settlements.map(settlement => {
      return {
        id: settlement.id,
        createdAt: moment(settlement.createdAt).format('DD/MM/YYYY'),
        sponsor: vuei18n.t(settlementService.getSponsorText(settlement.sponsorSlug)),
        amount: settlementService.sanitizeAmount(
          settlement.currencyCode,
          settlement.amount,
          false
        ),
        authorizations: settlement.authorizationCount,
        status: vuei18n.t(settlementService.getStatusText(settlement.status)),
        currencyCode: settlement.currencyCode,
        sponsorSettlementId: settlement.sponsorSettlementId
      }
    })
  },
  loadingSettlements: (state) => state.loadingSettlements,
  settlementsPage: (state) => {
    const { page } = state;
    return { ...page, number: page.number + 1 }
  },
  sponsorSelectionComplete: (state) => state.createSettlement.sponsorSelectionComplete,
  sponsorSelected: (state) => state.createSettlement.sponsorSlug,
  datesSelected: (state) => state.createSettlement.dates,
  dateFrom: (state) => state.createSettlement.dates.from ? moment(state.createSettlement.dates.from, "YYYY-MM-DD").format("DD/MM/YYYY") : "",
  dateTo: (state) => state.createSettlement.dates.to ? moment(state.createSettlement.dates.to, "YYYY-MM-DD").format("DD/MM/YYYY") : "",
  selectedSettlement: (state) => state.settlementSelected,
  getSettlementDetail: (state) => {
    return state.settlementDetail.map(detail => {
      return {
        id: detail.authorizationCode,
        claimId: detail.claimId,
        createdAt: moment(detail.createdAt).format('DD/MM/YYYY'),
        beneficiary: detail.beneficiaryName,
        memberCode: detail.beneficiaryMemberCode,
        branch: detail.providerBranchName,
        amount: settlementService.sanitizeAmount(
          detail.currencyCode,
          detail.amount,
          false
        )
      }
    })
  },
  actualStep: (state) => state.createSettlement.actualStep,
  getPendingAuthorizations: (state) => {
    return state.authorizations.map(item => {
      return {
        id: item.claimId,
        createdAt: moment(item.createdAt).format('DD/MM/YYYY'),
        beneficiaryName: item.beneficiaryName,
        memberCode: item.beneficiaryMemberCode,
        coverage: vuei18n.t(arcService.getType(item.transactionType))
      }
    })
  },
  getSettlementId: (state) => state.createSettlement.settlementId,
  getIncludedClaims: (state) => state.createSettlement.includedClaims,
  addAuthorizationsComplete: (state) => state.createSettlement.addAuthorizationsComplete,
  settlementCreationResult: (state) => state.createSettlement.createSettlementResult,
  createSettlementError: (state) => state.createSettlement.errorMessage
}